<ng-template #modalAddPaymentMethod let-c="close" let-d="dismiss">
  <wsb-modal
    (primary)="modalAddPaymentMethodForm()"
    cancelButtonEnable="true"
    (dismiss)="d()"
    title="{{ 'billing_tab_credit_card' | translate }}"
  >
    <div body>
      <!--                <form  (ngSubmit)="modalAddPaymentMethodForm()" method="post" id="setup-form">-->
      <div id="card-element"></div>
      <!--                </form>-->
    </div>
  </wsb-modal>
</ng-template>

<ng-template #modalDeletePaymentMethod let-c="close" let-d="dismiss">
  <wsb-modal
    (primary)="modalDeletePaymentMethodForm()"
    (dismiss)="d()"
    cancelButtonEnable="true"
    title="{{ 'common_attention' | translate }}"
    text="{{ 'settings_delete_payment_source_message' | translate }}"
  ></wsb-modal>
</ng-template>

<h3 class="my-5" translate>billing_tab_credit_card</h3>
<wsb-atlas-button *ngIf="!paymentMethod" class="my-3" [label]="'settings_edit_new_payment_method'" (click)="openModalAddPaymentMethod()">{{
  'settings_edit_new_payment_method' | translate
}}</wsb-atlas-button>
<wsb-atlas-button *ngIf="paymentMethod" class="my-3 me-3" [label]="'common_edit'" (click)="openModalAddPaymentMethod()">{{
  'common_edit' | translate
}}</wsb-atlas-button>
<wsb-atlas-button
  *ngIf="paymentMethod"
  [variant]="'danger'"
  class="my-3"
  [label]="'common_delete'"
  (click)="openModalDeletePaymentMethod()"
  >{{ 'common_delete' | translate }}</wsb-atlas-button
>
<p class="mt-5" *ngIf="!paymentMethod && dataLoaded" translate>settings_edit_no_payment_source</p>
<form class="mt-5" *ngIf="paymentMethod && dataLoaded">
  <div>
    <div class="page__form-wrap">
      <div class="form-group row">
        <label for="paymentMethodType" class="col-sm-4" translate>settings_edit_payment_source_source_type</label>
        <div class="col-sm-8" translate>
          <input
            type="text"
            class="form-control"
            id="paymentMethodType"
            value="{{ 'settings_edit_payment_source_source_type' + paymentMethod.paymentMethodType.toLowerCase() | translate }}"
            readonly="readonly"
          />
        </div>
      </div>
      <div class="form-group row">
        <label for="paymentMethodNumber" class="col-sm-4" translate>settings_edit_payment_source_card_number</label>
        <div class="col-sm-8">
          <input
            type="text"
            class="form-control"
            id="paymentMethodNumber"
            value="xxxx xxxx xxxx {{ paymentMethod.cardNumber }}"
            readonly="readonly"
          />
        </div>
      </div>
      <div class="form-group row">
        <label for="paymentMethodExpired" class="col-sm-4" translate>common_data_expired</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" id="paymentMethodExpired" value="{{ paymentMethod.cardExpire }}" readonly="readonly" />
        </div>
      </div>
      <div class="form-group row">
        <label for="paymentMethodPaymentSourceType" class="col-sm-4" translate>settings_edit_payment_source_type</label>
        <div class="col-sm-8">
          <input
            type="text"
            class="form-control"
            id="paymentMethodPaymentSourceType"
            value="{{ paymentMethod.cardBrand | uppercase }}"
            readonly="readonly"
          />
        </div>
      </div>
    </div>
  </div>
</form>
